import { graphql } from 'react-relay/legacy';

const homepageRootQuery = graphql`
    query homepageRootQuery(
        $isMobile: Boolean!
        $homepageId: String!
        $userId: String!
        $hasUserId: Boolean!
        $isClient: Boolean!
        $fetchInitialHomepage: Boolean!
        $zipCode: String
        $localRecentHistoryItemIds: [String] = []
        $fetchUserRecentHistoryItem: Boolean = false
        $locationItemsCount: Int
        $userType: String!
    ) {
        viewer {
            ...HpRespLayout_viewer
            homepage(rootId: $homepageId) {
                ...getHomePageMetaContent_homepage @relay(mask: false)
                # necessary to throw error & not cache homepage if no modules return
                modules {
                    __id
                }
            }
        }
    }
`;

const homepageVariables = {
    fetchInitialHomepage: true,
    hasRecentlyViewedItems: false,
    isMobile: false,
    homepageId: '',
    userId: '',
    hasUserId: false,
    recentlyViewedItemIds: [],
    userIds: [],
    isClient: false,
    countryCode: '',
    zipCode: '',
    locationItemsCount: 0,
    userType: '',
};

export { homepageRootQuery, homepageVariables };
